import { render, staticRenderFns } from "./ranqidetail.vue?vue&type=template&id=2a1f7ea3&scoped=true&"
import script from "./ranqidetail.vue?vue&type=script&lang=js&"
export * from "./ranqidetail.vue?vue&type=script&lang=js&"
import style0 from "./ranqidetail.vue?vue&type=style&index=0&id=2a1f7ea3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1f7ea3",
  null
  
)

export default component.exports